import { useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useFetchRapidDataById, useCurrentRapidData, useRapidDataError } from "@/store";
import LoadingScreen from "@/components/LoadingScreen";

export function RapidDataIdRedirect() {
    const { rapidDataId } = useParams<{ rapidDataId: string }>();
    const [searchParams] = useSearchParams();
    const step = searchParams.get("step");
    const fetchRapidDataById = useFetchRapidDataById();
    const error = useRapidDataError();
    const currentRapidData = useCurrentRapidData();
    const navigate = useNavigate();

    useEffect(() => {
        if (rapidDataId) {
            fetchRapidDataById(rapidDataId);
        }
    }, [rapidDataId, fetchRapidDataById]);

    useEffect(() => {
        if (currentRapidData && currentRapidData.id === rapidDataId) {
            const stepParam = step ? `?step=${step}` : "";
            navigate(
                `/redirect/workspace-id/${currentRapidData.workspaceId}/workflow-id/${currentRapidData.workflowId}${stepParam}`,
                { replace: true }
            );
        }
    }, [currentRapidData, navigate, rapidDataId, step]);

    useEffect(() => {
        if (error) {
            // eslint-disable-next-line no-console
            console.error("🐞[DEBUG - RapidDataIdRedirect] error", error);
            navigate("/");
        }
    }, [error, navigate]);

    return <LoadingScreen />;
}
